import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-news-grid',
  templateUrl: './news-grid.component.html',
  styleUrls: ['./news-grid.component.scss']
})
export class NewsGridComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}